/* eslint-disable react/prop-types */
import React from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import styled from 'styled-components'
import { FaRegEdit } from 'react-icons/fa'
import { AiOutlineSave } from 'react-icons/ai'

import identity from 'ramda/src/identity'

import moment from '../../lib/moment'
import bindActionCreators from '../../lib/utils/bindActionCreators'

import Button from '../../lib/components/Button'
import { Button as CustomButton } from '../../components/buttons'
import { modalButtons } from '../../components/buttons/modal-button'
// import VDivider from '../../lib/components/VDivider'
import NativeDropdown, { Dropdown } from '../../lib/components/NativeDropdown'

import { SPACING as constants, FONTS } from '../../constants'
import { ppsAction } from '../../actions'
import { ppsSelector } from '../../selectors'

import SubmitModal from '../../components/project-profit-sheet/SubmitModal'

import StatusBarContainer from './containers/StatusBarContainer'
import ProfitDisplayTab from './containers/ProfitDisplayTab'
import GrossProfitsContainer from './containers/GrossProfitsContainer'
import PriceCostContainer from './containers/PriceCostContainer'
import ManDayContainer from './containers/ManDayContainer'
import WManDayContainer from './containers/WManDayContainer'
import OverallSummaryContainer from './containers/OverallSummaryContainer'
// import OverallGPContainer from './containers/OverallGPContainer'
import GPSummaryContainer from './containers/GPSummaryContainer'
import MonthSelectorContainer from './containers/MonthSelectorContainer'
// import RevenueSummaryContainer from './containers/RevenueSummaryContainer'
import RevenueCardContainer from './containers/RevenueCardContainer'
import ProjectSummary from './containers/ProjectSummary'

import OtherCost from './other-cost'
import Percent from './percent'
import { COST_TYPE_MAPPING } from './constants'

import left_arrow from '../../static/images/left-arrow.svg'

const Layout = {
  Content: styled.div`
    /* tab bar + margin + status bar */
    height: calc(100% - (50px + 10px + 120px));
    padding: 0 ${constants.GAP} 50px;

    overflow-y: scroll;

    > :not(:first-child):not(:last-child) {
      margin-bottom: 16px;
    }
  `,
  StatusBarMenu: styled.div`
    display: flex;

    ${Dropdown.Container} {
      margin-right: 10px;
    }
  `,
  EditConfirm: styled.div`
    margin-left: 16px;

    display: grid;
    grid-auto-flow: column;
    column-gap: 12px;
  `,
  Carousel: styled.div`
    display: flex;

    > :not(:last-child) {
      margin-right: 24px;
    }
  `,
  GridCarousel: styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    /* grid-template-columns: repeat(auto-fit, minmax(380px, 380px)); */
    grid-gap: 8px;
  `,
  GridCard: styled.div`
    display: grid;
    grid-template-columns: 1fr;
    /* grid-template-columns: repeat(auto-fit, minmax(auto, 330px)); */
    grid-gap: 8px;
  `,
  RevenueWrapper: styled.div`
    display: flex;
    flex-direction: column;
    position: relative;
  `,
  RevenueGridCard: styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 8px;
  `,
  Header: styled.div`
    width: 100%;
    height: 50px;
    border: 1px solid #EAEAEA;
    background: #404040;
    cursor: pointer;
    padding-left: 32px;

    display: flex;
    align-items: center;

    /* position: absolute;
    top: 0;
    left: 0; */

    font-family: 'Gotham-Medium';
    font-size: 15px;
    color: #FFFFFF;
  `,
  ButtonWrapper: styled.div`
    height: 100%;
    display: flex;
    align-items: center;
    margin-right: 12px;
  `,
  ButtonGroup: styled.div`
    height: 100%;
    display: flex;
    align-items: center;
  `,
  Toggle: styled.div`
    width: auto;
    height: 27px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: ${p => (p.active ? '#2F80ED' : '#FFFFFF')};
    color: ${p => (p.active ? '#FFFFFF' : '#808080')};
    border: ${p => (p.active ? '1px solid #004AAE' : '1px solid #F2F2F2')};
    font-family: ${p => (p.active ? FONTS.GOTHAM_BOLD : FONTS.GOTHAM)};
    font-size: ${FONTS.SMALL_SIZE};
    padding: 8px;
    cursor: pointer;

    :nth-child(1) {
      border-radius: 4px 0 0 4px;
    }

    :nth-child(3) {
      border-radius: 0 4px 4px 0;
    }

    :hover {
      ${p => !p.active && `
        background: rgba(47, 128, 237, 0.08);
        border: 1px solid #004AAE;
        color: #2F80ED;
      `}
    }
  `,
  Arrow: styled.img`
    width : 10px;
    height : 10px;
    position: absolute;
    top: 18px;
    left: 0;
    margin: auto 14px;
    cursor: pointer;
  `,
}

/**
 * @typedef {object} Props
 * @property {typeof ppsAction.fetchProfitData} fetchProfitData
 * @property {typeof ppsAction.fetchProjectsData} fetchProjectsData
 * @property {typeof ppsAction.resetOtherCostEditing} resetOtherCost
 * @property {typeof ppsAction.setSubmitMonth} setSubmitMonth
 * @property {typeof ppsAction.submitProfitData} submitProfitData
 * @property {typeof ppsAction.updateOtherCost} updateOtherCost
 * @property {boolean} canEditCost
 * @property {boolean} canSubmit
 * @property {boolean} disableSaveOtherCost
 * @property {boolean} showAccounting
 * @property {import('moment').Moment} submitMonth
 * @property {object[]} unapprovedUsers
 * @property {object} alertData
 * @property {object} otherCost
 * @property {string} profitID
 * @property {string} projectCode
 */

/**
 * @typedef {object} State
 * @property {string} tab
 * @property {boolean} submit_modal
 * @property {boolean} edit_cost
 * @property {boolean} display
 * @property {string} cost_type
 * @property {function} cost_type_filter
 */

/**
 * @typedef {import('react-router').RouteComponentProps} RouteComponentProps
 * @extends {React.Component<Props & RouteComponentProps, State>}
 */
class ProjectSheet extends React.Component {
  constructor(props) {
    super(props)
    this.percent = React.createRef()
  }

  state = {
    tab: 'overview',
    submit_modal: false,
    edit_cost: false,
    edit_percent: false,
    display: false,
    cost_type: '-',
    cost_type_filter: identity,
    expand_revenue: true,
  }

  componentDidMount = async () => {
    const access_token = localStorage.getItem('access_token')
    const { setSubmitMonth, fetchProfitData } = this.props
    const { id: project_id } = this.props.match.params
    const { state: locationState = {} } = this.props.location
    const project = this.props.data.find(p => p.project_id === project_id)

    let startDate = ''
    if (project) {
      startDate = moment(project.start_date, 'DD/MM/YYYY')
    }
    const thisMonth = (locationState.month
      ? moment(locationState.month, 'YYYY/MMM')
      : (
        moment().subtract(1, 'month').isBefore(startDate)
          ? startDate.startOf('month')
          : (moment().subtract(1, 'month')).startOf('month')
      ))
    setSubmitMonth(thisMonth)
    await fetchProfitData(project_id, moment(thisMonth), access_token)
    this.setState({ display: !this.props.alertData })
  }

  componentWillUnmount = async () => {
    const access_token = localStorage.getItem('access_token')
    const { fetchProjectsData } = this.props

    await fetchProjectsData(access_token)
  }

  /** @param {string} tab */
  changeTab = tab => () => this.setState({ tab })
  toggleSubmitModal = () => this.setState(state => ({ submit_modal: !state.submit_modal }))

  // prettier-ignore
  toggleEditCost = () => {
    this.setState(state => ({ edit_cost: !state.edit_cost }), () => {
      this.props.resetOtherCost()
    })
  }

  /** @param {string} value */
  filterCostType = value =>
    this.setState({
      cost_type: value,
      cost_type_filter: value === '-' ? identity : row => row.type === value,
    })

  /**
   * @param {string} remark
   */
  ppsMonthSubmit = async remark => {
    const access_token = localStorage.getItem('access_token')
    const { submitMonth } = this.props
    const { id: project_id } = this.props.match.params

    await this.props.submitProfitData(project_id, submitMonth, remark, access_token)
  }

  ppsOtherCostSubmit = async () => {
    const access_token = localStorage.getItem('access_token')
    const { updateOtherCost, otherCost, fetchProfitData, submitMonth } = this.props
    const { id: project_id } = this.props.match.params

    const otherCostWithChangedTime = otherCost.map(obj =>
      obj
        .update('imported_date', imported_date => {
          const created_date = obj.get('created_date')

          if (!created_date) return imported_date
          return created_date
        })
        .delete('created_date')
    )

    await updateOtherCost(project_id, otherCostWithChangedTime, access_token)
    await fetchProfitData(project_id, submitMonth, access_token)
    this.toggleEditCost()
  }

  handleEditPercent = () => {
    const { edit_percent } = this.state
    if (edit_percent) {
      const actions = {
        cancel: this.closeResponseModal,
        discard: async () => {
          await this.percent.fetchProgressesData()
          this.setState({ edit_percent: !edit_percent })
          this.closeResponseModal()
        },
      }
      this.openDiscardModal(actions)
    } else this.setState({ edit_percent: !edit_percent })
  }

  handleDisplayPercent = is_delta => {
    const { percentTable, setPercentTable } = this.props
    if (this.state.edit_percent) {
      const actions = {
        cancel: this.closeResponseModal,
        discard: () => {
          this.setState({ edit_percent: !this.state.edit_percent })
          setPercentTable({ ...percentTable, is_delta })
          this.closeResponseModal()
        },
      }
      this.openDiscardModal(actions)
    } else setPercentTable({ ...percentTable, is_delta })
  }

  saveProgresses = async () => {
    const access_token = localStorage.getItem('access_token')
    const { id, progresses } = this.percent.getProgressesData()
    await this.props.updateProjectProgress(id, progresses, access_token)
    this.setState({ edit_percent: false })
    this.percent.fetchProgressesData()
  }

  handleExpandRevenue = () => {
    this.setState({ expand_revenue: !this.state.expand_revenue })
  }

  openDiscardModal = actions => {
    this.props.openResponseModal({
      is_open: true,
      res: {
        title: 'Unsaved changes',
        description: 'Are you sure you want to discard these changes?',
        actions: modalButtons('discard', actions),
      },
    })
  }

  closeResponseModal = () => {
    this.props.openResponseModal({ is_open: false, res: {} })
  }

  render = () => {
    const {
      activeTab,
      canSubmit,
      canEditCost,
      projectCode,
      submitMonth,
      disableSaveOtherCost,
      showAccounting,
      unapprovedUsers,
      // percentTable,
      isSubmitPPS,
      projectID,
      month,
      profitData,
      canSaveProgress,
    } = this.props
    const {
      tab,
      display,
      submit_modal,
      edit_cost,
      cost_type,
      cost_type_filter,
      edit_percent,
      expand_revenue,
    } = this.state

    const cost_types = Object.entries(COST_TYPE_MAPPING).map(([value, label]) => ({ value, label }))

    const showSubmitButton = tab === 'overview' && canSubmit
    const showEditCostButton = tab === 'other_cost' && showAccounting
    const shouldDisableSubmit = submitMonth.isAfter(moment().startOf('month'))

    // const isDelta = percentTable.is_delta

    return (
      display && (
        <React.Fragment>
          <SubmitModal
            isOpen={ submit_modal }
            toggle={ this.toggleSubmitModal }
            onConfirm={ this.ppsMonthSubmit }
            code={ projectCode }
            month={ submitMonth.format('MMMM YYYY') }
            unapproved_users={ unapprovedUsers }
          />
          <StatusBarContainer>
            <Layout.Toggle
              active={ tab === 'overview' }
              onClick={ this.changeTab('overview') }
            >
              Overview
            </Layout.Toggle>
            <Layout.Toggle
              active={ tab === 'other_cost' }
              onClick={ this.changeTab('other_cost') }
            >
              Non-Service Actual Cost
            </Layout.Toggle>
            <Layout.Toggle
              active={ tab === 'percent' }
              onClick={ this.changeTab('percent') }
            >
              Update Progress
            </Layout.Toggle>
            {/* <Button
              outline={ tab !== 'overview' }
              onClick={ this.changeTab('overview') }
              color="danger"
            >
              Overview
            </Button>
            <VDivider />
            <Button
              outline={ tab !== 'other_cost' }
              onClick={ this.changeTab('other_cost') }
              color="danger"
            >
              Non-Service Actual Cost
            </Button> */}
            <span style={ { flexGrow: 1 } } />
            <Layout.StatusBarMenu>
              {tab === 'percent' && (
                <Layout.ButtonWrapper>
                  { !edit_percent &&
                  <CustomButton
                    width='70px'
                    height='26px'
                    theme='#28a745'
                    onClick={ this.handleEditPercent }
                    disabled={ isSubmitPPS }
                    icon={ <FaRegEdit style={ { fontSize: 16 } } /> }
                  >
                    Edit
                  </CustomButton>
                  }
                  { edit_percent &&
                  <Layout.ButtonGroup>
                    <CustomButton
                      width='70px'
                      height='26px'
                      theme='#28a745'
                      disabled={ !canSaveProgress }
                      onClick={ this.saveProgresses }
                      icon={ <AiOutlineSave style={ { fontSize: 16 } } /> }
                    >
                      Save
                    </CustomButton>
                    <CustomButton
                      width='70px'
                      height='26px'
                      theme='#6c757d'
                      style={ { marginLeft: 12 } }
                      onClick={ this.handleEditPercent }
                    >
                      Cancel
                    </CustomButton>
                  </Layout.ButtonGroup>
                  }
                </Layout.ButtonWrapper>
              )}
              {(tab === 'overview' || tab === 'percent') && (
                <React.Fragment>
                  <MonthSelectorContainer percentTab={ tab === 'percent' } />
                  {showSubmitButton && (
                    <Button
                      disabled={ shouldDisableSubmit }
                      color="success"
                      style={ { marginLeft: 16 } }
                      onClick={ this.toggleSubmitModal }
                    >
                      Submit
                    </Button>
                  )}
                </React.Fragment>
              )}
              {tab === 'other_cost' &&
                (edit_cost ? (
                  <React.Fragment>
                    <MonthSelectorContainer viewMode />
                    <Layout.EditConfirm>
                      <Button color="secondary" onClick={ this.toggleEditCost }>
                        Cancel
                      </Button>
                      <Button
                        disabled={ disableSaveOtherCost }
                        color="success"
                        onClick={ this.ppsOtherCostSubmit }
                      >
                        Save
                      </Button>
                    </Layout.EditConfirm>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <NativeDropdown
                      options={ cost_types }
                      value={ cost_type }
                      onChange={ this.filterCostType }
                    />
                    <MonthSelectorContainer />
                    {showEditCostButton && (
                      <Button
                        disabled={ Boolean(canEditCost) }
                        color="success"
                        style={ { marginLeft: 16 } }
                        onClick={ this.toggleEditCost }
                      >
                        Edit Cost
                      </Button>
                    )}
                  </React.Fragment>
                ))}
            </Layout.StatusBarMenu>
          </StatusBarContainer>
          {tab === 'overview' && (
            <Layout.Content>
              <ProfitDisplayTab />
              <Layout.GridCard>
                <GrossProfitsContainer />
                <Layout.RevenueWrapper>
                  <Layout.Arrow
                    style={ {
                      transform: expand_revenue ? 'rotate(270deg)' : 'rotate(180deg)',
                    } }
                    src={ left_arrow }
                    collapse={ !expand_revenue }
                    onClick={ this.handleExpandRevenue }
                  />
                  <Layout.Header onClick={ this.handleExpandRevenue }>
                    Revenue Summary
                  </Layout.Header>
                  { expand_revenue &&
                  <Layout.RevenueGridCard>
                    <RevenueCardContainer title='Service Revenue' name='service' showMode />
                    <RevenueCardContainer title='Other Service Revenue' name='vendor' />
                    <RevenueCardContainer title='Hardware Revenue' name='hardware' />
                    <RevenueCardContainer title='HW/MA Revenue' name='hardware_ma' />
                    <RevenueCardContainer title='License Revenue' name='license' />
                    <RevenueCardContainer title='License/MA Revenue' name='license_ma' />
                    <RevenueCardContainer title='Subscription Revenue' name='subscription' />
                  </Layout.RevenueGridCard>
                  }
                </Layout.RevenueWrapper>
                { activeTab !== 'overview' && (
                  <React.Fragment>
                    <ProjectSummary />
                    <div />
                  </React.Fragment>
                ) }
              </Layout.GridCard>
              <PriceCostContainer />
              <ManDayContainer />
              <WManDayContainer />
              <OverallSummaryContainer />
              {/* <OverallGPContainer /> */}
              <GPSummaryContainer />
            </Layout.Content>
          )}
          {tab === 'other_cost' && (
            <OtherCost isEditing={ edit_cost } costFilter={ cost_type_filter } />
          )}
          {tab === 'percent' && (
            <Percent
              ref={ e => { this.percent = e } }
              month={ month }
              projectID={ projectID }
              profitData={ profitData }
              isEditing={ edit_percent }
              handleDisplayPercent={ this.handleDisplayPercent }
            />
          )}
        </React.Fragment>
      )
    )
  }
}

const mapStateToProps = createStructuredSelector({
  alertData: ppsSelector.getAlert,
  canEditCost: ppsSelector.canEditCost,
  canSubmit: ppsSelector.canSubmit,
  disableSaveOtherCost: ppsSelector.disableSaveOtherCost,
  otherCost: ppsSelector.otherCostEditing,
  profitID: ppsSelector.profitID,
  projectCode: ppsSelector.projectCode,
  showAccounting: ppsSelector.canUseAccountantActions,
  submitMonth: ppsSelector.submitMonth,
  unapprovedUsers: ppsSelector.getUnapprovedUsers,
  activeTab: ppsSelector.display,
  percentTable: ppsSelector.percentTable,
  projectID: ppsSelector.projectID,
  month: ppsSelector.submitMonth,
  isSubmitPPS: ppsSelector.isSubmitPPS,
  profitData: ppsSelector.profitData,
  canSaveProgress: ppsSelector.canSaveProgress,
  data: ppsSelector.overviews,
})

const mapDispatchToProps = bindActionCreators({
  fetchProfitData: ppsAction.fetchProfitData,
  fetchProjectsData: ppsAction.fetchProjectsData,
  resetOtherCost: ppsAction.resetOtherCostEditing,
  setSubmitMonth: ppsAction.setSubmitMonth,
  submitProfitData: ppsAction.submitProfitData,
  updateOtherCost: ppsAction.updateOtherCost,
  updateProjectProgress: ppsAction.updateProjectProgress,
  openResponseModal: ppsAction.openResponseModal,
  setPercentTable: ppsAction.setPercentTable,
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProjectSheet)



// WEBPACK FOOTER //
// ./src/pages/project-profit-sheet/project-sheet.js